import { SITES } from "configurations/Urls";
import apiClient from "utils/ApiClient";

const SITES_PUBLIC = `${SITES}/public`;

const SiteService = {
  async registerSite(payload) {
    const response = await apiClient.post(SITES, payload);
    return response.data;
  },

  async getSites(params, signal) {
    const response = await apiClient.get(`${SITES}?${params}`, { signal });
    return response.data;
  },

  async updateSite(payload) {
    const response = await apiClient.put(`${SITES}/${payload.id}`, payload);
    return response.data;
  },

  async deleteSite(siteId) {
    const response = await apiClient.delete(`${SITES}/${siteId}`);
    return response.data;
  },

  async shareSites(payload) {
    const response = await apiClient.post(`${SITES}/share`, payload);
    return response.data;
  },

  async updateShare(shareId, siteId, payload) {
    const response = await apiClient.put(
      `${SITES}/${siteId}/share/${shareId}`,
      payload
    );
    return response.data;
  },

  async getSharedSites(siteId) {
    const response = await apiClient.get(`${SITES}/${siteId}/share`);
    return response.data;
  },
};

export default SiteService;
